import { Devider } from "./devider";
export default Devider;
